import {Component, computed, effect, inject, input, OnInit, viewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {PageGridComponent} from '../../../shared/components/page-grid/page-grid.component';
import {GridEventOutput, GridModel} from '../../../shared/model/page-grid';
import {KtPaymentsFilterService} from '../../service/kt-payments-filter.service';
import {KtPaymentsGridService} from '../../service/kt-payments-grid.service';
import {IKtTravelerPaymentListItem} from '../../interfaces/kt-trip.interface';
import {KtPaymentDetailModalComponent} from '../kt-payment-detail-modal/kt-payment-detail-modal.component';

@Component({
  selector: 'app-kt-payments-list',
  templateUrl: './kt-payments-list.component.html',
  standalone: false,
})
export class KtPaymentsListComponent implements OnInit {
  private readonly filterService = inject(KtPaymentsFilterService);
  private readonly gridService = inject(KtPaymentsGridService);
  private readonly datePipe = inject(DatePipe);
  private readonly dialog = inject(MatDialog);

  readonly salesOrderId = input<number | null>(null);

  protected readonly gridRef = viewChild.required(PageGridComponent);

  protected readonly gridConfig = computed<GridModel<IKtTravelerPaymentListItem>>(() => ({
    gridDataTestId: 'kt-payments-list',
    gridTitle: 'Traveler Payments',
    defaultPageSize: 25,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Payment ID',
        sort: true,
        clickable: true,
        linkEventFunction: (item: IKtTravelerPaymentListItem) => `/KtTravelerPayment/${item.id}`,
      },
      ...(!this.salesOrderId() ? [{
        columnProperty: 'tripReference',
        columnHeader: 'Trip Reference',
        sort: true,
        textLeft: true,
      }] : []),
      {
        columnProperty: 'travelerName',
        columnHeader: 'Traveler',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'productTypeName',
        columnHeader: 'Product Type',
        sort: true,
      },
      {
        columnProperty: 'invoiceTypeName',
        columnHeader: 'Invoice Type',
        sort: false,
      },
      {
        columnProperty: 'amount',
        columnHeader: 'Amount',
        sort: false,
      },
      {
        columnProperty: 'currencyCode',
        columnHeader: 'Currency',
        sort: false,
      },
      {
        columnProperty: 'paymentDate',
        columnHeader: 'Payment Date',
        sort: true,
        processData: (item) => item ? (this.datePipe.transform(item, 'M/dd/yyyy') ?? '') : '',
      },
    ],
    gridGetService: this.gridService,
  }));

  public ngOnInit(): void {
    if (this.salesOrderId()) {
      this.gridService.salesOrderId = this.salesOrderId();
    }
  }

  constructor() {
    effect(() => {
      const filters = this.filterService.filtersValue();
      if (!filters.ReloadGrid) return;
      this.gridRef().getItems();
    });
  }

  protected handleColumnClick(event: GridEventOutput<IKtTravelerPaymentListItem>): void {
    if (event.column === 'id') {
      this.dialog.open(KtPaymentDetailModalComponent, {
        width: '65%',
        data: {id: event.item.id},
      });
    }
  }
}
